import React from "react";
import { getXPosition, getYPosition } from "../shared";
import "./style.scss";

type DataPointsProps = {
  points: Array<{ x: number; y: number }>;
  width: number;
  height: number;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

export const DataPoints: React.FC<DataPointsProps> = ({
  points,
  width,
  height,
  onClick,
}) => {
  return (
    <>
      {points.map((point, index) => (
        <div
          key={index}
          className={`quadrant-data-point`}
          data-x={point.x}
          data-y={point.y}
          onClick={onClick}
          style={{
            left: `${getXPosition(point.x, width)}px`,
            top: `${getYPosition(point.y, height)}px`,
          }}
        />
      ))}
    </>
  );
};

export default DataPoints;
